import * as React from 'react';
import {CSSProperties} from 'react';
import Radium, { StyleRoot } from 'radium';
import {IndigoFooter} from "./IndigoFooter";
import * as Tgcc from "../tgccGlobal";
import {Scroll} from "../Components/Scroll";
import {browserHistory} from 'react-router';
import { IndigoHeader } from './IndigoHeader';


const pageStyles: CSSProperties = {
    backgroundColor:'#F7F5F0'
}
const storyBoxStyles : CSSProperties = {
    width:'637px',
    margin:'5px auto 5px auto',
    position:'relative',
    zIndex:2,
}
const storyTextStyles : CSSProperties = {
    fontFamily: 'AveriaSerifLight',
    fontSize:'14px',
    color:'#626161',
    textAlign:'center',
    lineHeight:'1.5em',
    marginBottom:'50px'
}


const title : React.CSSProperties = {
    textAlign:'center',
    fontSize:'22px',
    letterSpacing:'0.2em',
    fontFamily:'Reitam',
    marginBottom:'48px',
    color:'#616060',
    display:'none'
}
const title2: React.CSSProperties = {
    textAlign:'center',
    fontSize:'22px',
    letterSpacing:'0.2em',
    fontFamily:'Reitam',
    marginBottom:'48px',
    marginTop:'48px',
    color:'#616060'
}



class _IndigoAbout extends React.Component<Tgcc.BaseProps,any> {


    openHome = () => {browserHistory.push(Tgcc.Routes.Indigo);};

    componentDidMount(){
        var tag = document.getElementById('about');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

    setError = (msg: string) => {
        this.setState({error: msg, isWaiting: false}, () => {
            this.scrollPageToView("TopProofError");
        });
        return false;
    }
    render() {
        return (
            <div style={pageStyles}>  
            <div id="about"></div>         
                <IndigoHeader />
                <div>            
                <div style={title}>ABOUT US</div>
                <div style={storyBoxStyles} className='storyDiv'>
                    <div style={title2}>HOW WE STARTED</div>
                    <p style={storyTextStyles} className='storyTxt'>Kite Hill.<br/>
                    A pasture on the left side of the road on the way to Clemson, SC. For many, it’s a landmark that serves as a welcome sign. For us, it’s a constant reminder of where we started and is what lead to our name, The Graphic Cow.<br/><br/>
                    In 1994, our challenge was to bring great art into the world of screenprinting. At the time, local companies printed only the basics of what their customers provided them. We knew our customers wanted something better, so we brought high-level custom artwork to the ordering process.<br/><br/>
                    High quality artwork was our first innovation but far from our last. We continue to elevate the customer’s experience. We were first to the market with an individual packaging approach we refer to as cow-tagging. This along with our individual payment systems allows for a personalized ordering experience you won’t find anywhere else.<br/><br/>
                    Many of our orders are designed around events, and we pride ourselves on our ability to deliver every order on time. Our state of the art printing capabilities allow us to provide our customers with the best experience possible.<br/><br/>
                    After more than {Tgcc.yearsInBusinessMilestone()} years in the apparel business our mission still remains the same.<br/>
                    Custom Apparel Made Simple.
                    </p>
                </div>
                </div>
                
                    <IndigoFooter state={this.props.state} router={this.props.router} />
              
            </div>
        )
    }
}

export var IndigoAbout = Radium(_IndigoAbout);
